<script setup lang="ts">
import TextCheckOptions from '@/components/Jobs/CopilotActivation/TextCheckOptions.vue';
import { computed } from 'vue';

const props = defineProps<{
  isSelected: boolean;
  isDisabled?: boolean;
  isPolicyLocked?: boolean;
}>();

const emit = defineEmits<{
  (e: 'select'): void;
}>();

const isOptionDisabled = computed(() => props.isDisabled || props.isPolicyLocked);

function handleSelect() {
  if (props.isPolicyLocked || props.isDisabled) {
    return;
  }

  emit('select');
}
</script>

<template>
  <div class="relative" :class="{ 'opacity-75': isOptionDisabled }">
    <TextCheckOptions
      :is-selected="isSelected"
      :is-disabled="isOptionDisabled"
      :is-policy-locked="isPolicyLocked"
      @click="handleSelect"
    >
      <template #title>Skip automated screening entirely</template>
      Don't ask candidates any questions at all
    </TextCheckOptions>
  </div>
</template>
